import SpriteSymbol from "../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"close\"><path d=\"M8.875 8.047l3.969-3.984q.188-.172.188-.43t-.18-.438-.438-.18-.43.188L8 7.172 4.016 3.203q-.172-.188-.43-.188t-.438.18-.18.438.188.43l3.969 3.984-3.969 3.984q-.188.172-.188.43t.18.438.438.18.43-.188L8 8.907l3.984 3.984q.172.188.43.188t.438-.18.18-.438-.188-.43z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/close.svg
// module id = 184
// module chunks = 0